<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLButtonAttributes } from 'svelte/elements';

  type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

  interface Props extends HTMLButtonAttributes {
    variant?: Variant;
    size?: 'sm' | 'md';
    children: Snippet;
  }

  let {
    variant = 'secondary',
    size = 'md',
    type = 'button',
    class: className,
    children,
    ...rest
  }: Props = $props();

  const variants: Record<Variant, string> = {
    primary: 'bg-accent text-on-accent hover:bg-accent-hover border-transparent',
    secondary: 'bg-surface text-ink border-line-strong/60 hover:bg-surface-2',
    ghost: 'bg-transparent text-ink border-transparent hover:bg-surface-2',
    danger: 'bg-danger text-surface border-transparent hover:opacity-90',
  };
  const sizes = {
    sm: 'min-h-8 px-3 text-sm pointer-coarse:min-h-11',
    md: 'min-h-10 px-4 text-sm pointer-coarse:min-h-11',
  };
</script>

<button
  {type}
  class={[
    'inline-flex items-center justify-center gap-2 rounded-lg border font-medium whitespace-nowrap transition-colors duration-150 select-none disabled:cursor-not-allowed disabled:opacity-50',
    variants[variant],
    sizes[size],
    className,
  ]}
  {...rest}
>
  {@render children()}
</button>
